export const higherEducationOptions = [
  "High School",
  "Bachelor",
  "Masters",
  "PhD",
  "Other",
  "Prefer not to say",
];
